module.exports = __webpack_public_path__ + "static/img/home.e42e6d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/platform/home.jpg
// module id = LDHK
// module chunks = 0